<app-matter-form-viewer-container
	[showCloseButton]="true"
	class="h-full"
	(onClose)="_onClose()"
>
</app-matter-form-viewer-container>
